import { useGetFavorites, usePageAction, useGetConsent } from '@dvag/dfs-ui-blocks/hooks';
import { useMemo } from 'react';
import { getContext, getToken } from '@dvag/dfs-orchestrator-client';
import { navigate, showMessage } from '@dvag/dfs-orchestrator-client/messengers';
import { appNames } from '@dvag/dfs-constant-config';

export const useGetFavoritesWithAction = (householdId?: string) => {
  const { checkHasConsent, checkHasAllAdultsConsent, checkHasAllPersonsBirthday } = useGetConsent(
    householdId,
    getToken,
  );

  const errorAlert = (message: string, title = ' ') =>
    showMessage(title, message, 'error', 'modal');

  const pagesQuery = useGetFavorites(getToken, true, true);

  const favorites = pagesQuery.data;

  const { pageAction } = usePageAction({
    householdId,
    getToken,
    getContext,
    currentLocation: `/${appNames.advisor}${window.location.pathname}`,
    hasConsent: checkHasConsent,
    hasAllAdultsConsent: checkHasAllAdultsConsent,
    hasAllPersonsBirthDate: checkHasAllPersonsBirthday,
    errorToast: errorAlert,
    navigate: (url, nextUrl) => navigate(url, nextUrl, true),
  });

  const favoritesWithAction = useMemo(
    () =>
      favorites.map((favorite) => ({
        ...favorite,
        onClick: () => pageAction(favorite.code),
      })),
    [favorites, pageAction],
  );

  return { data: favoritesWithAction, pageAction };
};
